import ToggleButton from "@material-ui/core/ToggleButton";
import React, { useMemo } from "react";
import useMarketplacesFilter from "../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import { MarketplaceButtonFC } from "./types";

const MarketplaceButton: MarketplaceButtonFC = ({ marketplace, ...props }) => {
  const { isLoading, active } = useMarketplacesFilter();
  const isSelected = useMemo(
    () => active.indexOf(marketplace.old.type) !== -1,
    [active]
  );
  return (
    <ToggleButton
      {...props}
      selected={isSelected}
      disabled={isLoading || (isSelected && active.length <= 1)}
      value={marketplace.old.type}
      sx={{ whiteSpace: "nowrap" }}
    >
      {marketplace.name}
    </ToggleButton>
  );
};

export default MarketplaceButton;
